// extracted by mini-css-extract-plugin
export default {"wrapper":"FixedBottomBanner-module__wrapper---3J5z","animatedBackground":"FixedBottomBanner-module__animatedBackground--+IXKC"};